import { takeUntil } from 'rxjs/operators';
import { Component } from '@angular/core'

import { select, Store } from '@ngrx/store'

import { Observable } from 'rxjs'

import { ContainerBase } from '../../../core/base/container-base'
import * as products from '../../actions/product'
import * as cart from '../../../cart/actions/cart'

import * as fromCart from '../../../cart/reducers'
import * as fromCatalog from '../../reducers'
import * as fromAuth from '../../../auth/reducers'

import { Product, ProductOrderHistory } from '../../../core/models/product'
import { SKU } from '../../models/sku'
import { AddCartEvent, ApiOrderline, CartProduct } from '../../../cart/models/cart-models';
import { Stock } from '../../models/stock'
import { FavoriteProduct, ToggleFavoriteEvent } from '../../models/favorite-product';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import chaining from '../../../core/helpers/chaining';
import * as fromBase from '../../../base/reducers';
import { Setting } from '../../../core/models/setting';
import { CombinedFacets } from '../../../facets/models/facet';

@Component({
  selector: 'app-details-container',
  templateUrl: './details-container.html'
})
export class DetailsContainer extends ContainerBase {
  loading$: Observable<boolean>
  product$: Observable<Product>
  selectedProductOrderHistory$: Observable<ProductOrderHistory[]>
  selectedProductBackorders$: Observable<ProductOrderHistory[]>
  favoritesProducts$: Observable<FavoriteProduct[]>
  stock$: Observable<{[code: string]: Stock}>
  skus$: Observable<SKU[]>
  cartProducts$: Observable<{[product: string]: CartProduct}>
  combinedFacets$: Observable<CombinedFacets>
  orderLines$: Observable<ApiOrderline[]>
  orderLines: ApiOrderline[]
  currentDate = new Date().toISOString()
  quantityPicker$: Observable<string>
  showSalesOrderPriceInfo: boolean
  viewType: string
  canDownloadImage: boolean

  detailsPageSettings$: Observable<Setting>

  allowOutOfStockOrdering: boolean = false

  constructor(
    public activeModal: NgbActiveModal,
    private store: Store<fromCatalog.State>
  ) {
    super()

    this.detailsPageSettings$ = this.store.pipe(select(fromBase.getItemDetailsPageSettings), takeUntil(this.destroyed$))

    this.loading$ = store
      .pipe(
        select(fromCatalog.isDetailsLoading),
        takeUntil(this.destroyed$)
    )
    this.product$ = store
      .pipe(
      select(fromCatalog.getSelectedProduct),
      takeUntil(this.destroyed$)
      )
    this.selectedProductOrderHistory$ = store
      .pipe(
        select(fromCatalog.getSelectedProductOrderHistory),
        takeUntil(this.destroyed$)
      )
    this.selectedProductBackorders$ = store
      .pipe(
        select(fromCatalog.getSelectedProductBackorders),
        takeUntil(this.destroyed$)
      )
    this.favoritesProducts$ = this.store
      .pipe(
        select(fromCatalog.getFavorites),
        takeUntil(this.destroyed$)
      )
    this.stock$ = store
      .pipe(
      select(fromCatalog.getStock),
      takeUntil(this.destroyed$)
    )
    this.skus$ = store
      .pipe(
      select(fromCatalog.getSKUs),
      takeUntil(this.destroyed$)
      )
    this.cartProducts$ = store
      .pipe(
      select(fromCart.getCartProducts),
      takeUntil(this.destroyed$)
    )
    this.orderLines$ = store
      .pipe(
        select(fromCart.getCurrentOrderLines),
        takeUntil(this.destroyed$)
      )
    this.orderLines$
      .subscribe(orderLines => this.orderLines = orderLines)
    this.combinedFacets$ = store
      .pipe(
        select(fromCatalog.getCombinedFacets),
        takeUntil(this.destroyed$)
      )
    this.quantityPicker$ = store
        .pipe(
          select(fromBase.getQuantityPicker),
          takeUntil(this.destroyed$)
        )

    this.store.pipe(
      select(fromAuth.getUserPermissions),
      takeUntil(this.destroyed$)
    ).subscribe((permissions) => {
      this.showSalesOrderPriceInfo = permissions.indexOf('VIEW_SALESORDER_PRICE_INFO') > -1
    })

    this.store.pipe(
      select(fromAuth.getUserPermissions),
      takeUntil(this.destroyed$)
    ).subscribe((permissions) => {
      // First check if user is allowed to see stock info. If not, allowOutOfStockOrdering should be true since no stock info is available
      if (permissions.indexOf('VIEW_STOCK_INFO') === -1) {
        this.allowOutOfStockOrdering = true;
      } else {
        // User is allowed to see stock. Check for ALLOW_OUT_OF_STOCK_ORDERING permission.
        if (permissions.indexOf('ALLOW_OUT_OF_STOCK_ORDERING') > -1) {
          this.allowOutOfStockOrdering = true;
        }
      }

      if (permissions.indexOf('DOWNLOAD_IMAGES') > -1) {
        this.canDownloadImage = true;
      }
    })
  }

  toggleFavorite(event: ToggleFavoriteEvent) {
    event.isFavorite
      ? this.store.dispatch(new products.RemoveFavorite(event.product))
      : this.store.dispatch(new products.AddFavorite(event.product))
  }

  onClose() {
    this.activeModal.dismiss()
  }

  addCart(event: AddCartEvent) {
    const orderLineId = chaining(this.orderLines.find(line => chaining(line, 'product._id') === chaining(event, 'product')), '_id')

    if (chaining(event, 'quantity') > 0) {
      this.store.dispatch(new cart.Add({
        product: event.product,
        quantity: event.quantity
      }))
    } else if (event.quantity <=0 && orderLineId)
      this.store.dispatch(new cart.Remove({
        lineId: orderLineId
      }))
  }
}
